<div class="modal-content">
    <div class="modal-body">
        <div class="row w-90 mx-auto">
            <div class="col-sm-12 px-5 mb-2">
                <h1 class="text-center">
                    Protege tu cuenta con MFA
                </h1>
            </div>
            <div class="col-sm-12 px-5 mb-2">
                <div class="row">
                    <div class="col-12 mb-3 font-size">
                        <p>Se informa que la autenticación multifactor (MFA) será obligatoria a partir del <span class="font-weight-bold text-danger">30/09/2025</span>.</p>
                    </div>
                    <div class="col-12 mb-3 font-size">
                        <p>Les recomendamos que se familiaricen con el proceso de configuración y autenticación.</p>
                    </div>
                    <div class="col-12 mb-3 font-size">
                        <p>Puedes revisar los pasos <span class="font-weight-bold text-primary cursor-pointer" (click)="goToTutorial()">aquí</span></p>
                    </div>
                </div>
            </div>
            <div class="col-12 d-flex justify-content-center">
                <button mat-flat-button 
                    class="custom-button-error mx-5"
                    (click)="close()"
                >
                    <mat-icon 
                        aria-hidden="false" 
                        aria-label="Icono de cerrar" 
                        fontIcon="close" 
                        class="icon-download"
                    ></mat-icon>
                    Cerrar
                </button>
                <button mat-flat-button 
                    class="custom-button-tertiary mx-5"
                    (click)="goToConfig()"
                >
                    <mat-icon 
                        aria-hidden="false" 
                        aria-label="Icono de ir" 
                        fontIcon="arrow_forward" 
                        class="icon-download"
                    ></mat-icon>
                    Ir a Configurar
                </button>
            </div>
        </div>
    </div>
</div>
